import LoadingOverlay from "components/shared/LoadingOverlay";
import { useEffect, useState } from "react";
import { PDFViewer, pdf } from "@react-pdf/renderer";

const ReportPDFDocViewer = ({ doc, height = "500px", showToolbar }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    setProgress(0);

    // Simulate progress for UX while generating PDF
    const interval = setInterval(() => {
      setProgress((prev) => (prev < 90 ? prev + 10 : prev)); // Cap at 90% until PDF is ready
    }, 300);

    pdf(doc)
      .toBlob()
      .then(() => {
        clearInterval(interval);
        setProgress(100);
        setTimeout(() => setIsLoading(false), 300); // Small delay for smooth UX
      });

    return () => clearInterval(interval);
  }, [doc]);

  return (
    <>
      {isLoading && (
        <>
          <div style={{ width: "100%", background: "#eee", borderRadius: "8px" }}>
            <div
              style={{
                width: `${progress}%`,
                height: "4px",
                background: "#93278F",
                borderRadius: "8px",
                transition: "width 0.3s ease"
              }}
            ></div>
          </div>
          <p style={{ textAlign: "center", marginTop: "10px" }}>{progress}%</p>
        </>
      )}
      <PDFViewer width="100%" showToolbar={showToolbar} height={height}>
        {doc}
      </PDFViewer>
    </>
  );
};

export default ReportPDFDocViewer;
